<template>
  <div class="page-content prose">
    <div class="container">
      <div class="flex justify-center pb-8">
        <ContentInfoLinks />
      </div>

      <h1>Theorie examen oefenen?</h1>
      <p>
        Als je graag je theorie examen wilt oefenen, ben je aan het goede adres
        op Rijscholenvergelijker.nl. Hier heb je namelijk de mogelijkheid om
        geheel kosteloos en vrijblijvend informatie aan te vragen van
        verschillende rijscholen bij jou in de buurt. Deze rijscholen nemen
        vervolgens zelf contact met je op, waarna je je uitgebreid kunt laten
        informeren. Vraag naar de mogelijkheden om je theorie examen te oefenen
        bij deze scholen en volg je theorie- en praktijklessen bij één en
        dezelfde rijschool.
      </p>

      <h2>Waarom theorie examen oefenen?</h2>
      <p>
        Door je theorie examen te oefenen en lessen te volgen bij de rijschool
        die je begeleidt naar je rijbewijs, vergroot je de kans dat je meteen de
        eerste keer slaagt voor je
        <nuxt-link to="/informatie-over-rijscholen/theorie-examen">
          theorie examen.
        </nuxt-link>
        Omdat dit examen behoorlijk duur is, kunnen de kosten voor je rijbewijs
        flink oplopen als je het meerdere keren moet overdoen. Bovendien krijg
        je meer inzicht en vertrouwen in verkeerssituaties tijdens je
        praktijklessen als je ondertussen theorielessen volgt. En dat betekent
        weer dat je sneller op mag voor je
        <nuxt-link to="/informatie-over-rijscholen/praktijkexamen">
          praktijkexamen </nuxt-link
        >! Denk je dat je er baat bij hebt als je je theorie examen kunt oefenen
        bij jouw rijschool? Informeer dan per rijschool naar de kosten en
        mogelijkheden!
      </p>

      <h2>Gratis informatie</h2>
      <p>
        Wil jij weten bij welke rijscholen je in de omgeving terecht kunt als je
        je theorie examen wilt oefenen met behulp van een aantal lessen? Laat
        deze <nuxt-link to="/"> rijscholen </nuxt-link> dan snel contact met jou
        opnemen en vraag naar de mogelijkheden! Vergeet daarnaast natuurlijk
        niet te informeren naar zaken zoals het uurtarief en het
        slagingspercentage. Kies voor de beste rijschool en begeleiding, zorg
        dat je snel slaagt voor je theorie en praktijk en houd honderden euro’s
        over!
      </p>
    </div>
  </div>
</template>

<script>
import AbstractPage from 'chimera/all/components/page/AbstractPage'
import ContentInfoLinks from '~/components/layout/ContentInfoLinks'

export default {
  components: {
    ContentInfoLinks,
  },

  extends: AbstractPage,

  layout: 'content',

  /**
   * @returns {object}
   */
  data() {
    return {
      headTitle: 'Theorie examen oefenen? Gratis informatie aanvragen!',
      headDescription:
        'Wil je weten bij welke rijschool je je theorie examen kunt oefenen? Vraag op Rijscholenvergelijker.nl gratis informatie aan en kom erachter!',
    }
  },
}
</script>
